import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoleGuardService as RoleGuard } from '../providers/authentication/role-guard.service';
import { Http } from '@angular/http';
import { InformesComponent } from '../views/Informes/Informes.component';
import {InputSwitchModule} from 'primeng/inputswitch';
import {MenubarModule} from 'primeng/menubar';
import {ButtonModule} from 'primeng/button';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import { AppOcupacionChartComponent } from '../componentes/OcupacionChart/ocupacionChart.component';
import {AppLocalizacionChartComponent} from '../componentes/LocalizacionChart/localizacionChart.component';
import {AppHistoricoChartComponent} from '../componentes/HistoricoChart/historicoChart.component';
import {AppHistoricoSeccionChartComponent} from '../componentes/historicoSeccionChart/historicoSeccionChart.component';
import {AppHistoricoTipologiaSeccionChartComponent} from '../componentes/historicoTipologiaSeccionChart/historicoTipologiaSeccionChart.component';
//import {AppImprimirChartComponent} from '../componentes/Imprimir/Imprimir.component';
import {AppCoincidenciasChartComponent} from '../componentes/CoincidenciasChart/coincidenciasChart.component';
import { PlanoModule } from 'interiores-mapa';
import {SelectButtonModule} from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import {
	AccordionModule
} from 'primeng/primeng';

import {

	ConfirmDialogModule,
	DialogModule,
	FileUploadModule,
	GrowlModule,
	PickListModule,
	DropdownModule,
	PaginatorModule,
} from 'primeng/primeng';

import { TableModule } from 'primeng/table';
import { Permisos } from '../providers/authentication/permisos.service';
import { TranslateLoader, TranslateStaticLoader } from 'ng2-translate/src/translate.service';
import { TranslateModule } from 'ng2-translate';
import { ComponentesModule } from './componentes.module';
import { InputTextModule } from 'primeng/inputtext';
import { AppModule } from '../app.module';
import { DashboardModule } from './dashboard.module';
import { MapaCalorModule } from 'mapacalorcomponent/dist/mapa-calor';
import {SliderModule} from 'primeng/slider';

export const InformesModuleRoutes: Routes = [
	{
		path: 'informes',
		component: InformesComponent, // the `component` property is necessary when the lazy module provides some service in order to injection work well. If defined, the referenced component's template should have an element with the `<router-outlet>` directive.
		children: [
			{
				path: '',
				component: InformesComponent,
				canActivate: [RoleGuard],
				data: {
					// TODO: Dar de alta el nuevo permiso en BBDD y agregar esta linea
					expectedRole: [Permisos.Dashboard_menu]
					// expectedRole: [Permisos.Informes_menu]
				}
			},
		],
		pathMatch: 'prefix'
	}
];

@NgModule({
	imports: [
		SelectButtonModule,
		SliderModule,
		AccordionModule,
		MapaCalorModule,
		DashboardModule,
		InputSwitchModule,
		ButtonModule,
		ComponentesModule,
		MenubarModule,
		InputTextModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(InformesModuleRoutes),
		CalendarModule,
		// CardModule,
		ConfirmDialogModule,
		// DataGridModule,
		DialogModule,
		// EditorModule,
		FileUploadModule,
		GrowlModule,
		PickListModule,
		TableModule,
		MultiSelectModule,
		PaginatorModule,
		// TabMenuModule,
		DropdownModule,
		PlanoModule,
		TooltipModule,
		// ToolbarModule,
		TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: function(http: Http){ return new TranslateStaticLoader(http, '/assets/i18n', '.json'); },
            deps: [Http]
        })
	],

	declarations: [
		InformesComponent,
		AppOcupacionChartComponent,
		AppLocalizacionChartComponent,
		AppHistoricoChartComponent,
		AppHistoricoSeccionChartComponent,
		AppCoincidenciasChartComponent,
		AppHistoricoTipologiaSeccionChartComponent
		//AppImprimirChartComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class InformesModule {

	static forRoot(): ModuleWithProviders {
		return {
		  ngModule: InformesModule
		  // providers: [CreditCardService]
		};
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/modules/informes.module.ts